var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRipleyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "101px",
    height: "38px",
    viewBox: "0 0 101 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 101,
    height: 38,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,83.137255%,84.705882%)",
      fillOpacity: 1
    },
    d: "M 80.5 38.003906 L 83.660156 38.003906 L 83.660156 28.53125 L 80.5 28.53125 Z M 80.5 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,7.843137%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 23.730469 38.003906 L 31.625 38.003906 L 31.625 28.53125 L 23.730469 28.53125 Z M 23.730469 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,0%)",
      fillOpacity: 1
    },
    d: "M 6.3125 38.003906 L 11.046875 38.003906 L 11.046875 28.53125 L 6.3125 28.53125 Z M 6.3125 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,35.686275%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 15.859375 38.003906 L 20.59375 38.003906 L 20.59375 28.53125 L 15.859375 28.53125 Z M 15.859375 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,83.137255%,84.705882%)",
      fillOpacity: 1
    },
    d: "M 12.621094 38.003906 L 15.871094 38.003906 L 15.871094 28.53125 L 12.621094 28.53125 Z M 12.621094 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.784314%,9.019608%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 31.59375 38.003906 L 34.75 38.003906 L 34.75 28.53125 L 31.59375 28.53125 Z M 31.59375 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.784314%,9.019608%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 0 38.003906 L 4.734375 38.003906 L 4.734375 28.53125 L 0 28.53125 Z M 0 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,7.843137%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 93.140625 38.003906 L 97.878906 38.003906 L 97.878906 28.53125 L 93.140625 28.53125 Z M 93.140625 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,83.137255%,84.705882%)",
      fillOpacity: 1
    },
    d: "M 34.742188 38.003906 L 39.476562 38.003906 L 39.476562 28.53125 L 34.742188 28.53125 Z M 34.742188 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.784314%,9.019608%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 39.46875 38.003906 L 44.203125 38.003906 L 44.203125 28.53125 L 39.46875 28.53125 Z M 39.46875 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,0%)",
      fillOpacity: 1
    },
    d: "M 20.578125 38.003906 L 23.742188 38.003906 L 23.742188 28.53125 L 20.578125 28.53125 Z M 20.578125 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.65625 38.003906 L 85.238281 38.003906 L 85.238281 28.53125 L 83.65625 28.53125 Z M 83.65625 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,0%)",
      fillOpacity: 1
    },
    d: "M 47.375 38.003906 L 52.09375 38.003906 L 52.09375 28.53125 L 47.375 28.53125 Z M 47.375 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,7.843137%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 52.09375 38.003906 L 56.832031 38.003906 L 56.832031 28.53125 L 52.09375 28.53125 Z M 52.09375 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,35.686275%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 56.828125 38.003906 L 59.988281 38.003906 L 59.988281 28.53125 L 56.828125 28.53125 Z M 56.828125 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.784314%,9.019608%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 59.980469 38.003906 L 61.578125 38.003906 L 61.578125 28.53125 L 59.980469 28.53125 Z M 59.980469 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,0%)",
      fillOpacity: 1
    },
    d: "M 61.570312 38.003906 L 66.304688 38.003906 L 66.304688 28.53125 L 61.570312 28.53125 Z M 61.570312 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.871094 38.003906 L 69.441406 38.003906 L 69.441406 28.53125 L 67.871094 28.53125 Z M 67.871094 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 45.777344 38.003906 L 47.367188 38.003906 L 47.367188 28.53125 L 45.777344 28.53125 Z M 45.777344 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.035156 38.003906 L 12.613281 38.003906 L 12.613281 28.53125 L 11.035156 28.53125 Z M 11.035156 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.784314%,9.019608%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 72.605469 38.003906 L 80.5 38.003906 L 80.5 28.53125 L 72.605469 28.53125 Z M 72.605469 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,7.843137%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 69.441406 38.003906 L 72.605469 38.003906 L 72.605469 28.53125 L 69.441406 28.53125 Z M 69.441406 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,35.686275%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 85.234375 38.003906 L 89.976562 38.003906 L 89.976562 28.53125 L 85.234375 28.53125 Z M 85.234375 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,0%)",
      fillOpacity: 1
    },
    d: "M 89.976562 38.003906 L 93.144531 38.003906 L 93.144531 28.53125 L 89.976562 28.53125 Z M 89.976562 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.784314%,9.019608%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 97.867188 38.003906 L 101 38.003906 L 101 28.53125 L 97.867188 28.53125 Z M 97.867188 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,7.843137%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 4.730469 38.003906 L 6.308594 38.003906 L 6.308594 28.53125 L 4.730469 28.53125 Z M 4.730469 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,7.843137%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 44.199219 38.003906 L 45.785156 38.003906 L 45.785156 28.53125 L 44.199219 28.53125 Z M 44.199219 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,83.137255%,84.705882%)",
      fillOpacity: 1
    },
    d: "M 66.300781 38.003906 L 67.878906 38.003906 L 67.878906 28.53125 L 66.300781 28.53125 Z M 66.300781 38.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.078125 19.113281 C 18.078125 19.054688 18 19.03125 18 19.03125 C 17.210938 18.882812 16.480469 18.320312 15.925781 17.726562 C 15.015625 16.753906 14.257812 15.511719 13.957031 14.929688 C 13.871094 14.726562 13.996094 14.699219 13.996094 14.699219 C 15.523438 14.089844 15.777344 12.527344 15.777344 12.097656 C 15.777344 10.109375 13.941406 9.519531 12.289062 9.519531 C 11.660156 9.519531 11.457031 9.574219 10.800781 9.574219 C 10.046875 9.574219 9.59375 9.519531 9.472656 9.519531 C 9.371094 9.519531 9.300781 9.613281 9.300781 9.722656 C 9.300781 10.199219 10.371094 9.390625 10.371094 10.988281 L 10.371094 17.386719 C 10.371094 18.867188 9.359375 18.457031 9.359375 18.8125 C 9.359375 18.929688 9.484375 18.976562 9.5625 18.976562 C 9.941406 18.976562 10.371094 18.921875 10.984375 18.921875 C 11.757812 18.921875 11.949219 18.976562 12.394531 18.976562 C 12.714844 18.976562 12.769531 18.910156 12.769531 18.8125 C 12.769531 18.355469 11.402344 19.058594 11.402344 17.128906 L 11.402344 10.386719 C 11.402344 9.988281 11.6875 9.988281 12.101562 9.988281 C 13.605469 9.988281 14.789062 10.839844 14.816406 12.457031 C 14.828125 13.550781 14.03125 14.589844 12.699219 14.589844 C 12.234375 14.589844 12.339844 14.5625 12.234375 14.5625 C 12.167969 14.5625 12.101562 14.589844 12.101562 14.683594 C 12.101562 14.808594 12.199219 14.867188 12.308594 14.902344 C 12.457031 14.96875 12.796875 15.023438 13.144531 15.574219 C 14.03125 17.066406 15.035156 19.296875 17.308594 19.296875 C 18.164062 19.296875 18.078125 19.191406 18.078125 19.113281 M 91.039062 9.234375 C 90.515625 9.234375 89.839844 9.402344 89.339844 9.847656 C 88.414062 10.683594 87.789062 12.078125 87.429688 12.972656 C 87.316406 13.273438 87.203125 13.371094 87.136719 13.371094 C 87.058594 13.371094 86.984375 13.285156 86.875 13.125 L 85.488281 10.824219 C 85.410156 10.707031 85.253906 10.496094 85.253906 10.28125 C 85.253906 9.890625 85.863281 9.875 85.863281 9.652344 C 85.863281 9.535156 85.707031 9.519531 85.617188 9.519531 C 85.488281 9.519531 85.136719 9.574219 84.707031 9.574219 C 83.828125 9.574219 83.570312 9.519531 83.222656 9.519531 C 83.128906 9.519531 83.050781 9.628906 83.050781 9.722656 C 83.050781 9.945312 83.691406 9.785156 84.03125 10.359375 L 86.207031 13.921875 C 86.308594 14.085938 86.507812 14.355469 86.507812 14.605469 L 86.507812 17.84375 C 86.507812 18.789062 85.503906 18.441406 85.503906 18.8125 C 85.503906 18.960938 85.578125 18.976562 85.691406 18.976562 C 85.8125 18.976562 86.285156 18.921875 86.867188 18.921875 C 87.347656 18.921875 88.109375 18.976562 88.300781 18.976562 C 88.484375 18.976562 88.601562 18.960938 88.601562 18.839844 C 88.601562 18.425781 87.53125 18.796875 87.53125 17.632812 L 87.53125 14.449219 C 87.792969 13.636719 88.335938 12.324219 89.148438 11.292969 C 89.789062 10.464844 90.539062 9.835938 91.550781 9.476562 C 91.613281 9.449219 91.679688 9.421875 91.679688 9.347656 C 91.679688 9.226562 91.039062 9.234375 91.039062 9.234375 M 70.015625 10.921875 C 70.015625 10.023438 69.984375 10.078125 71.238281 10.078125 C 71.761719 10.078125 73.113281 10 73.445312 10.453125 C 73.664062 10.761719 73.445312 11.398438 73.765625 11.398438 C 73.839844 11.398438 74.023438 11.296875 74.023438 9.8125 C 74.023438 9.652344 74 9.519531 73.894531 9.519531 C 73.492188 9.519531 72.292969 9.574219 72.03125 9.574219 C 71.484375 9.574219 70.808594 9.519531 68.34375 9.519531 C 67.96875 9.519531 67.894531 9.574219 67.894531 9.679688 C 67.894531 9.839844 68.179688 9.871094 68.277344 9.890625 C 68.980469 10 68.980469 10.636719 68.980469 11.242188 L 68.980469 17.328125 C 68.980469 17.957031 68.960938 18.332031 68.617188 18.492188 C 68.199219 18.707031 68.070312 18.679688 68.050781 18.839844 C 68.050781 18.945312 68.125 18.976562 68.238281 18.976562 C 68.761719 18.976562 69.308594 18.929688 69.832031 18.921875 C 70.820312 18.890625 71.816406 18.976562 72.800781 18.976562 C 73.371094 18.976562 73.664062 19 74.078125 18.519531 C 74.382812 18.179688 74.730469 17.707031 74.730469 17.222656 C 74.730469 17.199219 74.714844 17.066406 74.625 17.066406 C 74.453125 17.066406 74.007812 18.441406 71 18.441406 C 69.910156 18.441406 70.015625 18.121094 70.015625 17.328125 L 70.015625 14.878906 C 70.015625 14.675781 69.976562 14.449219 70.246094 14.449219 L 72.175781 14.449219 C 73.269531 14.449219 72.824219 15.621094 73.230469 15.621094 C 73.320312 15.621094 73.371094 15.566406 73.371094 15.453125 C 73.371094 15.085938 73.34375 14.746094 73.34375 14.394531 C 73.34375 13.964844 73.371094 13.511719 73.371094 13.042969 C 73.371094 12.9375 73.332031 12.796875 73.230469 12.796875 C 72.917969 12.796875 73.269531 13.863281 71.914062 13.863281 L 70.507812 13.863281 C 69.984375 13.863281 70.015625 13.863281 70.015625 13.410156 Z M 54.667969 17.328125 C 54.667969 18.121094 54.5625 18.441406 55.660156 18.441406 C 58.667969 18.441406 59.109375 17.066406 59.277344 17.066406 C 59.371094 17.066406 59.382812 17.199219 59.382812 17.222656 C 59.382812 17.703125 59.046875 18.179688 58.730469 18.519531 C 58.316406 19 58.03125 18.976562 57.453125 18.976562 C 56.46875 18.976562 55.476562 18.890625 54.484375 18.921875 C 53.96875 18.929688 53.417969 18.976562 52.898438 18.976562 C 52.777344 18.976562 52.699219 18.945312 52.699219 18.839844 C 52.722656 18.679688 52.855469 18.707031 53.277344 18.492188 C 53.613281 18.332031 53.636719 17.957031 53.636719 17.328125 L 53.636719 10.558594 C 53.636719 9.871094 52.542969 9.960938 52.542969 9.691406 C 52.542969 9.550781 52.636719 9.519531 52.804688 9.519531 C 53.074219 9.519531 53.480469 9.574219 54.113281 9.574219 C 54.863281 9.574219 55.175781 9.519531 55.371094 9.519531 C 55.539062 9.519531 55.617188 9.550781 55.617188 9.707031 C 55.617188 10.019531 54.667969 9.679688 54.667969 10.839844 Z M 40.304688 10.386719 C 40.304688 9.988281 40.59375 9.988281 41.015625 9.988281 C 42.511719 9.988281 43.722656 10.839844 43.722656 12.457031 C 43.722656 13.660156 42.941406 14.3125 41.617188 14.3125 C 41.144531 14.3125 40.867188 14.230469 40.765625 14.230469 C 40.699219 14.230469 40.636719 14.265625 40.636719 14.355469 C 40.636719 14.597656 41.386719 14.660156 41.519531 14.660156 C 44.296875 14.660156 44.6875 12.632812 44.6875 12.097656 C 44.6875 10.109375 42.851562 9.519531 41.195312 9.519531 C 40.574219 9.519531 40.359375 9.574219 39.710938 9.574219 C 38.953125 9.574219 38.496094 9.519531 38.378906 9.519531 C 38.28125 9.519531 38.210938 9.613281 38.210938 9.722656 C 38.210938 10.199219 39.28125 9.390625 39.28125 10.988281 L 39.28125 17.386719 C 39.28125 18.867188 38.257812 18.457031 38.257812 18.8125 C 38.257812 18.929688 38.394531 18.976562 38.472656 18.976562 C 38.851562 18.976562 39.28125 18.921875 39.898438 18.921875 C 40.660156 18.921875 40.855469 18.976562 41.300781 18.976562 C 41.625 18.976562 41.675781 18.910156 41.675781 18.8125 C 41.675781 18.355469 40.304688 19.058594 40.304688 17.132812 Z M 26.90625 10.667969 C 26.890625 9.691406 25.847656 9.960938 25.847656 9.667969 C 25.847656 9.550781 25.875 9.519531 25.980469 9.519531 C 26.464844 9.519531 26.933594 9.574219 27.414062 9.574219 C 27.816406 9.574219 28.21875 9.519531 28.625 9.519531 C 28.835938 9.519531 28.871094 9.550781 28.871094 9.652344 C 28.871094 9.976562 27.9375 9.667969 27.9375 10.667969 L 27.9375 17.84375 C 27.9375 18.746094 29.097656 18.441406 29.097656 18.839844 C 29.097656 18.929688 29.050781 18.976562 28.835938 18.976562 C 28.535156 18.976562 27.972656 18.921875 27.414062 18.921875 C 26.621094 18.921875 26.34375 18.976562 26.164062 18.976562 C 25.929688 18.976562 25.890625 18.910156 25.890625 18.777344 C 25.890625 18.382812 26.90625 18.832031 26.90625 17.5 Z M 26.90625 10.667969 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipleyLogo);
export default __webpack_public_path__ + "static/media/Ripley-logo.b178f45a0c714e56ed02dd5f2cd3580e.svg";
export { ForwardRef as ReactComponent };